export default "__VITE_ASSET__6ZNFPDOR__"